module.exports = __webpack_public_path__ + "img/logo.282ec0ad.png";